module.exports = __webpack_public_path__ + "static/media/tfakkarni-react-game-by-saad.firebaseapp.com_(iPhone 6_7_8 Plus) (1).04287abb.png";